






























import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import MainLayout from '@/modules/common/layout/components/shared/MainLayout.vue'
import { ErrorMessages, FlushMessages } from '@/modules/common/layout/models/types/Messages'
import AdminTopHeader from '@/modules/common/layout/components/admin/AdminTopHeader.vue'
import BaseDrawer from '@/modules/common/layout/components/shared/base/BaseDrawer.vue'

@Component({
  metaInfo: {
    title: 'پنل مدیریت ادمین'
  },
  components: {
    BaseDrawer,
    MainLayout,
    AdminTopHeader
  }
})
export default class AdminLayout extends MainLayout {
  $refs!: {
    drawer: BaseDrawer
  }
  @Prop() sidebar!: object
  @Prop() orig_user!: string | null
  @Prop() unreadNotifications!: number
  @Prop() showSwitchUser!: boolean
  @Prop() errors!: ErrorMessages
  @Prop() flush!: FlushMessages
  //
  @Prop() page_header?: String
  @Prop() page_sub_header?: String
  @Prop() header_icon?: String
  //
  dark: boolean = true

  toggleDrawer() {
    this.$refs.drawer.toggleDrawer()
  }
}
